import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/idea-management/inbox')({});
